module.exports = __webpack_public_path__ + "8f7839dc8a9682f2473398e9a272abd9.png";